<template>
  <div class="pt-10 pb-5 component-div">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          class="ml-2 question-tital-name"
          :class="isFieldDisabled ? 'disable-question' : ''"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span v-if="componentData.isSkippable" :class="isFieldDisabled ? 'disable-question' : ''" class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }">Optional</span>
        <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
          Skipped
        </div>

        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span v-if="hasFieldError" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
        <span v-if="hasFieldWarning" class="text-danger pl-5 fw-bold">{{ fieldWarningText }}</span>
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <div class="pl-40 pt-40">
        <div v-if="!componentData.verticalScale">
          <div v-if="activityInfo && activityInfo.newLayout == true">
            <dsSliderCustomScale :ref="'slider_' + componentData.id" v-if="!componentData.verticalScale" :value="getValueForCustomScale()" :piecewise="true" direction="horizontal" class="horizontal-vue-slider pl-20 pt-20 pb-25" :data="translatedScaleLabels" :piecewiseLabel="true" :min="componentData.minValue" :max="componentData.maxValue" :interval="componentData.partitions" disabled />
          </div>
          <div v-else>
            <dsSlider :ref="'slider_' + componentData.id" v-if="!componentData.verticalScale" :value="getValueForCustomScale()" :piecewise="true" direction="horizontal" class="horizontal-vue-slider pl-20 pt-20 pb-25" :data="translatedScaleLabels" :piecewiseLabel="true" :min="componentData.minValue" :max="componentData.maxValue" :interval="componentData.partitions" disabled />
          </div>
        </div>
        <dsSlider :ref="'slider_' + componentData.id" v-if="componentData.verticalScale" :value="getValueForCustomScale()" :piecewise="true" width="5" height="350px" direction="vertical" class="vertical-vue-slider pl-20" :data="translatedScaleLabels" :piecewiseLabel="true" :min="componentData.minValue" :max="componentData.maxValue" :interval="componentData.partitions" disabled />
      </div>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pl-30">
        <b-col md="8" sm="12" class="mt-25">
          <dsSlider
            :ref="'slider_' + componentData.id"
            v-if="!componentData.verticalScale"
            :value="!!getValueForCustomScale() ? getValueForCustomScale() : this.translatedScaleLabels[0]"
            :piecewise="true"
            direction="horizontal"
            class="horizontal-vue-slider pt-20 pb-25 mb-5"
            :data="translatedScaleLabels"
            :piecewiseLabel="true"
            :min="componentData.minValue"
            :max="componentData.maxValue"
            :interval="componentData.partitions"
            :disabled="isFieldDisabled"
            @drag-end="onAnswerChange"
            :clickable="isClickable"
            :dotSize="pointerValue"
            :tooltip="showTooltip"
            @click.native="showPointer"
          />

          <dsSlider
            :ref="'slider_' + componentData.id"
            v-if="componentData.verticalScale"
            :value="!!getValueForCustomScale() ? getValueForCustomScale() : this.translatedScaleLabels[0]"
            :piecewise="true"
            width="5"
            height="350px"
            direction="vertical"
            class="vertical-vue-slider pl-50"
            :data="translatedScaleLabels"
            :piecewiseLabel="true"
            :min="componentData.minValue"
            :max="componentData.maxValue"
            :interval="componentData.partitions"
            :disabled="isFieldDisabled"
            @drag-end="onAnswerChange"
            :clickable="isClickable"
            :dotSize="pointerValue"
            :tooltip="showTooltip"
            @click.native="showPointer"
          />
        </b-col>
        <b-col cols="4"> </b-col>
      </b-row>
      <span class="activity-form__clear pl-50" :class="[{ clearOptionDisabled: isFieldDisabled }, isFieldDisabled ? 'disable-question' : '']" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
      <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses" :class="isFieldDisabled ? 'disable-question' : ''">
        <label class="fs-12" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
        <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
          <span v-if="!componentData.answer">{{ showScore(componentData.skipScore) || 0 }}</span>
          <span v-else>{{ componentData.actualScore || 0 }}</span>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-16">{{ selectedAnswer }}</div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                <span v-if="!componentData.answer && componentData.isSkippable">{{ showScore(componentData.skipScore) || 0 }}</span>
                <span v-else>{{ componentData.actualScore || 0 }}</span>
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import dsSlider from "@/lib/ds-slider-component";
import langTranslate from "./lang-translate";
import dsSliderCustomScale from "@/lib/ds-slider-component-custom-scale";

export default {
  name: "activity-form-custom-scale-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {},
      hasFieldWarning: false,
      fieldWarningText: "",
      pointerValue: 0,
      showTooltip: false,
      isClickable: true
    };
  },
  mounted() {
    let compId = document.getElementById(`${this.componentData.id}`)
    if (compId != null && compId != undefined) {
      let ulListItems = document.getElementById(`${this.componentData.id}`).getElementsByClassName('vue-slider-piecewise')[0];
      if (ulListItems != null && ulListItems != undefined) {
        ulListItems.firstChild.style.width = '0px';
        ulListItems.lastChild.style.width = '0px';
      }
    }
    this.componentData.answer = this.getValueForCustomScale();
    if (this.completeEdit) {
      this.componentData.defaultAnswer = this.componentData.answer;
    } else {
      this.componentData.defaultAnswer = "";
    }
    this.calculateScoresMap();
    if (this.componentData) {
      const $this = this;
      const slider = "slider_" + this.componentData.id;
      if ($this.$refs[slider]) {
        setTimeout(() => {
          $this.$refs[slider].refresh();
        }, 5000);
      }
    }
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
      if (this.componentData.answer) {
        this.pointerValue = 16;
        this.showTooltip = "always";
        this.isClickable = false;
      }
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    },
    completeEdit: {
      type: Boolean,
      default: false
    }
  },

  components: {
    dsSlider,
    dsSliderCustomScale
  },
  watch: {
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.checkForFieldErrors();
      }
    },
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && !!this.componentData.answer && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  computed: {
    translatedScaleLabels() {
      const translatedLabels = [];
      if (this.componentData && !!this.componentData.formattedLabels && this.componentData.formattedLabels.length) {
        this.componentData.formattedLabels.forEach((label, index) => {
          const translation = this.translateToActiveLang(`${this.translationKeyInitial}_formattedLabels_${index}_label`, label);
          translatedLabels.push(translation);
        });
      } else if (this.componentData && !!this.componentData.labels && this.componentData.labels.length) {
        this.componentData.labels.forEach((label, index) => {
          const translation = this.translateToActiveLang(`${this.translationKeyInitial}_labels_${index}_label`, label);
          translatedLabels.push(translation);
        });
      }

      return translatedLabels;
    },

    selectedAnswer() {
      if (this.componentData && !!this.componentData.formattedLabels && this.componentData.formattedLabels.length && this.componentData.answer) {
        const { formattedLabels, answer } = this.componentData;
        const answerIndex = formattedLabels.indexOf(answer);
        return this.translateToActiveLang(`${this.translationKeyInitial}_formattedLabels_${answerIndex}_label`, answer);
      } else if (this.componentData && !!this.componentData.labels && this.componentData.labels.length && this.componentData.answer) {
        const { labels, answer } = this.componentData;
        const answerIndex = labels.indexOf(answer);
        return this.translateToActiveLang(`${this.translationKeyInitial}_labels_${answerIndex}_label`, answer);
      }

      return "";
    }
  },
  methods: {
    isScoreExcluded(answer) {
      let excludeScore = false;
      let labelIndex = null;
      for (let index = 0; index < this.componentData.labels.length; index++) {
        if (this.componentData.labels[index] == answer) {
          labelIndex = index;
        }
      }
      if (labelIndex != null) {
        if (this.componentData.excludeScores && this.componentData.excludeScores[labelIndex]) {
          excludeScore = this.componentData.excludeScores[labelIndex];
        }
      }
      return excludeScore;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    calculateScoresMap() {
      if (this.componentData.labels && this.componentData.scores) {
        this.componentData.labels.forEach((label, index) => {
          this.scoresMap[label] = this.componentData.scores[index] || 0;
        });
      }
    },
    resetField() {
      this.pointerValue = 0;
      this.showTooltip = false;
      this.componentData.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.defaultAnswer = "";
      this.resetAllErrors();
      this.$emit("getQuestionScores");
      this.$forceUpdate();
    },
    clearAnswer() {
      this.pointerValue = 0;
      this.showTooltip = false;
      this.isClickable = true;
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    checkForFieldErrors() {
      const { dataEditChecks, answer } = this.componentData;
      this.componentData.dataChecks = [];
      this.resetAllErrors();

      if (this.isFieldDisabled) {
        return;
      }
      let softDataCheck = false;
      if (dataEditChecks) {
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && (answer === "undefined" || answer === "")) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              softDataCheck = true;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              return false;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && (answer === "undefined" || answer === "")) {
              this.hasFieldError = true;
              this.fieldErrorText = `This field is required.`;
              this.componentData.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (!this.componentData.isSkippable && (typeof this.componentData.answer === "undefined" || this.componentData.answer === "")) {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required.";
      }
    },
    getValueForCustomScale() {
      if (this.componentData.answer || this.componentData.answer === 0 || this.componentData.answer === null) {
        return this.componentData.answer;
      } else {
        return undefined;
      }
    },
    onAnswerChange(event) {
      this.$nextTick(() => {
        this.componentData.answer = event.val;
        this.componentData.defaultAnswer = event.val;
        this.checkForFieldErrors();
        this.componentData.computedScore = this.scoresMap[this.componentData.answer];
        this.componentData.actualScore = this.scoresMap[this.componentData.answer];
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    showPointer(event) {
      this.pointerValue = 16;
      this.showTooltip = "always";
      let answer;
      if (event.target.__vue__) {
        answer = event.target.__vue__.val;
      } else if (event.target.parentElement.__vue__) {
        answer = event.target.parentElement.__vue__.val;
      }
      if (this.isClickable == true) {
        this.isClickable = false;
        this.componentData.answer = answer;
        this.componentData.computedScore = this.scoresMap[answer];
        this.componentData.actualScore = this.scoresMap[answer];
        this.$emit("onAnswerChange", this.componentData);
      }
      this.checkForFieldErrors();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.activity-form-preview {
  &__date-dropdown {
    width: 100px;
  }
  &__time-disabled {
    line-height: 1.8;
    color: #495057;
    background-color: #e9ecef;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    height: 40px;
    border-radius: 0.25rem;
    font-size: 15px;
    width: 100px;
  }
}
.component-div:hover .icons-div {
  display: block;
}
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}

.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
